export var FontWeight;

(function (FontWeight) {
  FontWeight[FontWeight["REGULAR"] = 400] = "REGULAR";
  FontWeight[FontWeight["MEDIUM"] = 600] = "MEDIUM";
  FontWeight[FontWeight["BOLD"] = 700] = "BOLD";
  FontWeight[FontWeight["BOLDER"] = 900] = "BOLDER";
})(FontWeight || (FontWeight = {}));

export var EBreakpoints = {
  MOBILE1: "mobile-1",
  MOBILE2: "mobile-2",
  TABLET1: "tablet-1"
};